import { Router, ActivatedRoute, Params } from '@angular/router';
import { Component, OnInit, Input } from '@angular/core';
import { CustomProffixService, UserSessionService, LocalStorageService, UserDefaults } from '../../services';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import {
  Login,
  Mitarbeiter,
  MitarbeiterService,
  StundenService,
  Stunden
} from '@proffix/restapi-angular-library';

@Component({
  selector: 'app-hours-worked',
  templateUrl: './hours-worked.component.html',
  styleUrls: ['./hours-worked.component.css']
})
export class HoursWorkedComponent implements OnInit {
  proffixLogin: Login = null;

  private _page = 1;
  itemsPerPage = 10;
  isLoaded = false;
  isManager = false;
  isTeamleiter = false;

  filterMitarbeiterNr = 0;
  filterDateFrom: NgbDateStruct;
  filterDateTo: NgbDateStruct;

  userDefaults: UserDefaults;

  stundenList: Stunden[];
  listOfMitarbeiter: Mitarbeiter[];

  constructor(
    private _customProffixService: CustomProffixService,
    private _userSessionService: UserSessionService,
    private _localStorageService: LocalStorageService,
    private _mitarbeiterService: MitarbeiterService,
    private _stundenService: StundenService) {
  }

  ngOnInit() {
    this._userSessionService.getProffixLogin().subscribe(data => {
      this.proffixLogin = data;
      this.isManager = this._userSessionService.isManager();
      this.isTeamleiter = this._userSessionService.isTeamleiter();

      if (data) {
        this.userDefaults = this._localStorageService.loadUserDefaults(data.Benutzer);

        if (this.isManager === false && this.isTeamleiter == false) {
          this.filterMitarbeiterNr = data.Mitarbeiter.MitarbeiterNr;
        } else {
          this.filterMitarbeiterNr = this.userDefaults.FilterMitarbeiterNr ? this.userDefaults.FilterMitarbeiterNr : 0;
        }

        if (this.userDefaults) {
          this.filterDateFrom = this.userDefaults.FilterDateFrom;
          this.filterDateTo = this.userDefaults.FilterDateTo;
          this.itemsPerPage = this.userDefaults.ItemsPerPage ? this.userDefaults.ItemsPerPage : 10;
        }

        // load the list of all Mitarbeiter that the current user is allowed to see
        this._customProffixService
          .getListOfAssignedMitarbeiter(this.proffixLogin.Mitarbeiter.MitarbeiterNr, this.isManager)
          .subscribe(result => {
            this.listOfMitarbeiter = this.SortMitarbeiterByName(result);

            // finally load the Stunden
            this.loadStunden();
          });
      }
    });
  }

  get page(): number {
    // transform value for display
    return this._page;
  }

  @Input()
  set page(value: number) {
    if (value > 0) {
      this._page = value;
      this.loadStunden();
    }
  }

  public changeItemsPerPage() {
    this.search();
  }

  public pageBack() {
    if (this.page > 1) {
      this.page = this.page - 1;
    }
  }

  public pageNext() {
    this.page = this.page + 1;
  }

  public search() {
    this._page = 1;
    this.loadStunden();

    // store the search form values
    this.userDefaults.FilterMitarbeiterNr = this.filterMitarbeiterNr;
    this.userDefaults.FilterDateFrom = this.filterDateFrom;
    this.userDefaults.FilterDateTo = this.filterDateTo;
    this.userDefaults.ItemsPerPage = this.itemsPerPage;

    this._localStorageService.saveUserDefaults(this.proffixLogin.Benutzer, this.userDefaults);
  }

  loadStunden() {
    this.isLoaded = false;
    
    this._userSessionService.handleRequest(() => {
      return this._stundenService.getAll(
        {
          // @ts-ignore: Unknown but functional GET parameter
          gesperrt: 'any',
          sort: '-Datum,-StartZeit',
          limit: this.itemsPerPage,
          offset: this.getOffset(),
          filter: this.getFilterString(),
        });
    }).subscribe((result) => {
      // @ts-ignore: Because of the ignore statement above this doesn't work anymore with the compiler (no one knows why)
      this.stundenList = result;
      this.isLoaded = true;
    });
  }

  private SortMitarbeiterByName(listOfMitarbeiter: Mitarbeiter[]): Mitarbeiter[] {
    listOfMitarbeiter.sort((x, y) => {
      if (x.Adresse.Name < y.Adresse.Name) {
        return -1;
      } else if (x.Adresse.Name > y.Adresse.Name) {
        return 1;
      } else {
        return 0;
      }
    });

    return listOfMitarbeiter;
  }

  getFilterString(): string {
    let filter = '';

    if (this.filterMitarbeiterNr !== 0) {
      filter = filter + 'Mitarbeiter==' + this.filterMitarbeiterNr + ',';
    } else {
      // filter for all employees the current role is assigned to see
      filter = filter + '(';
      this.listOfMitarbeiter.forEach(m => {
        filter = filter + 'Mitarbeiter==' + m.MitarbeiterNr + '|';
      });
      filter = filter.slice(0, -1);
      filter = filter + '),';
    }

    if (this.filterDateFrom && this.filterDateFrom.year) {
      filter = filter + 'Datum>=D"' + this.getDateStringFromNgbDateStruct(this.filterDateFrom) + '",';
    }
    if (this.filterDateTo && this.filterDateTo.year) {
      filter = filter + 'Datum<=D"' + this.getDateStringFromNgbDateStruct(this.filterDateTo) + '",';
    }

    return filter.slice(0, -1);
  }

  private getDateStringFromNgbDateStruct(date: NgbDateStruct): string {
    let result = '';

    result += date.year + '-';
    if (date.month < 10) { result += '0'; }
    result += date.month + '-';
    if (date.day < 10) { result += '0'; }
    result += date.day;

    return result;
  }

  public filterVisibleMitarbeiter(ma: Mitarbeiter): boolean {
    return ma && ma.Zusatzfelder && ma.Zusatzfelder.Z_Zeitmanagement_Rolle && ma.Zusatzfelder.Z_Zeitmanagement_Rolle !== '';
  }

  getOffset() {
    return (this.page - 1) * this.itemsPerPage;
  }
}



// WEBPACK FOOTER //
// C:/.NET Projects/Angular Apps/TimeManagement/src/app/dialogs/hours-worked/hours-worked.component.ts